// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__CPx4i","item":"Breadcrumbs_item__1gFKA","link":"Breadcrumbs_link__GIYDb"};